import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ComissaoJulgadoraService } from '../comissao-julgadora-service'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

export interface HistoricoComissaoData {
  concursoId: number
}

interface HistoricoItem {
  id: number
  nome: string
  papelOriginal: string
  status: string
  motivoRemocao: string | null
  removidoEm: string | null
  removidoPor: string | null
}

@Component({
  selector: 'inscricoes-historico-comissao-dialog',
  templateUrl: './historico-comissao-dialog.component.html',
  styleUrls: ['./historico-comissao-dialog.component.scss'],
})
export class HistoricoComissaoDialogComponent implements OnInit {
  private destroyRef = inject(DestroyRef)

  historico: HistoricoItem[] = []
  loading = true

  private readonly statusLabels: Record<string, string> = {
    REMOVIDO_CONSULTA: 'Removido na composição',
    REMOVIDO_CONFLITO: 'Removido por conflito',
    SUBSTITUIDO: 'Substituído',
  }

  private readonly papelLabels: Record<string, string> = {
    TITULAR: 'Titular',
    SUPLENTE: 'Suplente',
    PRESIDENTE: 'Presidente',
    DESLIGADO: 'Desligado',
  }

  constructor(
    public dialogRef: MatDialogRef<HistoricoComissaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistoricoComissaoData,
    private readonly comissaoService: ComissaoJulgadoraService
  ) {}

  ngOnInit(): void {
    this.comissaoService.listarHistorico(this.data.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (items) => {
        this.historico = items
        this.loading = false
      },
      error: () => {
        this.loading = false
      },
    })
  }

  getStatus(status: string): string {
    return this.statusLabels[status] || status
  }

  getPapel(papel: string): string {
    return this.papelLabels[papel] || papel
  }

  fechar(): void {
    this.dialogRef.close()
  }
}
